import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Form } from "react-bootstrap";
import { isNil } from "lodash";

import "./styles.scss";
import HelperTextLabel from "../HelperTextLabel";

const MaterialContainer = ({
  children,
  label,
  id,
  isLabelAnimated,
  placeholder,
  helperText,
  meta,
  disabled,
  readonly,
  classes,
  value,
  borderless,
  forceLabel,
  type,
  enableHelperTextTooltip,
}) => {
  let showLabel =
    type !== "dropdown" || forceLabel // Show label for all inputs
      ? true
      : !!label &&
        (!!placeholder || meta.active || (!isNil(value) && value !== ""));
  // Hide label for Dropdown and show placeholder instead
  if (type === "dropdown" && label && !placeholder) {
    showLabel = false;
  }
  // Show label for Dropdown when value set
  if (type === "dropdown" && label && !isNil(value) && value !== "") {
    showLabel = true;
  }

  const shouldShowError = !!(
    !readonly &&
    (meta.touched || meta.submitting) &&
    meta.error
  );

  const isNotActive = !meta.active && !(value || value === 0) && !forceLabel;
  const labelClasses = classNames(
    classes?.label,
    isLabelAnimated && "form-label-animated",
    isNotActive && "form-label-inactive"
  );

  return (
    <Form.Group
      className={classNames(
        "material-form-group",
        disabled && "material-form-group-disabled",
        readonly && "material-form-group-readonly",
        shouldShowError && "material-form-group-error",
        borderless && "material-form-group-borderless",
        classes?.group
      )}
    >
      {children}
      {showLabel && (
        <Form.Label className={labelClasses} htmlFor={id}>
          {label}
        </Form.Label>
      )}
      <HelperTextLabel
        meta={meta}
        helperText={helperText}
        classes={classes}
        readonly={readonly}
        enableHelperTextTooltip={enableHelperTextTooltip}
      />
    </Form.Group>
  );
};

MaterialContainer.defaultProps = {
  required: false,
  borderless: false,
  meta: {},
  classes: {},
};

MaterialContainer.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  id: PropTypes.string,
  isLabelAnimated: PropTypes.bool,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  borderless: PropTypes.bool,
  readonly: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  classes: PropTypes.shape({
    label: PropTypes.string,
    group: PropTypes.string,
    text: PropTypes.string,
  }),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  forceLabel: PropTypes.bool,
  enableHelperTextTooltip: PropTypes.bool,
};

export default MaterialContainer;
